import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';

import { Button } from '@/components/ButtonComponent';
import { LineSeparator } from '@/components/LineSeparator';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { useActiveWallet } from '@/hooks/use-active-wallet';
import { useHasSocialWallet } from '@/hooks/use-has-social-wallet';
import { useRootNavigation } from '@/hooks/use-root-navigation';
import { resetToAccountScreen } from '@/navigation/navigation';
import { common } from '@/styles/styles';
import { toFraction } from '@/utils/numeric/fraction';

import { WithdrawalFrame } from '../components/WithdrawalFrame';
import { WithdrawalMethods } from '../components/WithdrawalMethods';
import { selectAllWithdrawMethods, useWithdrawalMethods } from '../hooks/use-withdrawal-methods';

export const styles = StyleSheet.create({
    separator: {
        borderBottomWidth: 1,
        width: '100%',
    },
    bottomContainer: { bottom: 0, backgroundColor: ds.colorValue.background.neutral.base },
});

/**
 * View to show list of withdrawal methods
 * */
export const ChooseWithdrawalMethod = () => {
    const hasSocialWallet = useHasSocialWallet();
    const { t } = useTranslation(['wallet']);
    const rootNavigation = useRootNavigation();
    const { balance, wallet } = useActiveWallet();
    const amount = hasSocialWallet ? toFraction(wallet.CASH?.real_amount) : balance;
    const { data: withdrawMethods = [] } = useWithdrawalMethods({ select: selectAllWithdrawMethods });

    return (
        <WithdrawalFrame balance={amount}>
            <WithdrawalMethods methods={withdrawMethods} />
            <MaxWidthWrapper>
                <View style={[common.relative, common.full, styles.bottomContainer]}>
                    <LineSeparator style={styles.separator} />
                    <SizedBox value={16} />
                    <View style={[common.paddingHorizontal]}>
                        <Text fontWeight="500" fontSize={13} color={ds.colorToken.text.secondary} textAlign={'center'}>
                            {hasSocialWallet ? t('redeem_status_prompt') : t('withdrawal_status_prompt')}
                        </Text>
                        <SizedBox value={15} />
                        <Button
                            hierarchy={'subtle'}
                            label="View Transaction History"
                            onPress={() => {
                                BetrAnalytics.trackProductEvent(AnalyticsEvent.WITHDRAW_VIEW_TRANSACTION_HISTORY);
                                resetToAccountScreen(rootNavigation, 'TransactionHistory');
                            }}
                        />
                    </View>
                    <SizedBox value={50} />
                </View>
            </MaxWidthWrapper>
        </WithdrawalFrame>
    );
};
